import React from "react"
import { Carousel } from "../carousel"
import { useTranslation } from "next-i18next"
import tw, { styled, css } from "twin.macro"
import { ReactComponent as LeCoco } from "../../assets/homepage/leCoco.svg"
import { ReactComponent as Neffex } from "../../assets/homepage/neffex.svg"
import { ReactComponent as FlyByMidnight } from "../../assets/homepage/flyByMidnight.svg"
import { ReactComponent as Isra } from "../../assets/homepage/isra.svg"
import { isMobile } from "react-device-detect"

const Wrapper = styled.div(() => [
  tw`flex flex-col items-center tablet-lg:(flex-row )`,
  css`
    svg {
      ${tw`w-[328px] h-[335px] tablet-lg:(w-[683px] h-[671px])`}
    }
  `,
])
export const Testimonies = () => {
  const { t } = useTranslation("homepage")
  const contents = [
    {
      image: <LeCoco />,
      name: t("le_coco"),
      testimony: t("le_coco_testimony"),
      color: "#ED47A8",
    },
    {
      image: <Neffex />,
      name: t("neffex"),
      testimony: t("neffex_testimony"),
      color: "#E3EC4C",
    },
    {
      image: <FlyByMidnight />,
      name: t("fly_by_midnight"),
      testimony: t("fly_by_midnight_testimony"),
      color: "#61D5FF",
    },
    {
      image: <Isra />,
      name: t("99_podcast"),
      testimony: t("99_podcast_testimony"),
      color: "#BC3EF7",
    },
  ]

  const slides = contents.map(({ image, name, testimony, color }, index) => (
    <div key={index} tw="w-[354px] h-[569px] tablet-lg:(w-[1281px] h-[753px])">
      <Wrapper>
        {image}
        <div
          tw="absolute bottom-[20px] text-center border border-white rounded-lg bg-[#ffffff20] w-[319px] h-[243px] flex flex-col items-center justify-center p-5 space-y-5 tablet-lg:(w-[654px] h-[498px] right-[80px] bottom-auto p-14)"
          css={"filter: drop-shadow(-15px 24px 16px rgba(0, 0, 0, 0.25));backdrop-filter: blur(15px);"}
        >
          <span tw="font-bold text-lg tablet-lg:text-3xl">{name}</span>
          <p
            tw="font-bold text-xs tablet-lg:text-xl"
            css={`
              span {
                color: ${color};
              }
            `}
            dangerouslySetInnerHTML={{ __html: testimony }}
          />
        </div>
      </Wrapper>
    </div>
  ))

  return (
    <section tw="py-5 tablet-lg:py-16">
      <Carousel {...{ children: slides, groupCells: 1, cellAlign: isMobile ? "center" : "left" }} />
    </section>
  )
}
